import { render, staticRenderFns } from "./AdvertsView.vue?vue&type=template&id=589f331e&"
import script from "./AdvertsView.vue?vue&type=script&lang=js&"
export * from "./AdvertsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports